import { render, staticRenderFns } from "./CustomertEditTabPartTemplate.vue?vue&type=template&id=2a3380b3"
import script from "./CustomertEditTabPartTemplate.vue?vue&type=script&lang=js"
export * from "./CustomertEditTabPartTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports